import ReactDOMServer from 'react-dom/server';

/*
    Returns string which is svg representation of the given component.
    Might be useful when adding inline css via "data:image/svg+xml;utf8"
*/
function encodeSvg(reactElement) {
    // ReactDOMServer.renderToStaticMarkup removes: `xmlns="http://www.w3.org/2000/svg"`
    // so it must be added at the end because browsers do not show svg if this attribute is missing.
    return ('data:image/svg+xml;utf8,' +
        ReactDOMServer.renderToStaticMarkup(reactElement)
            // Make sure that `xmlns` attribute is not there, to prevent duplicates
            .replace('xmlns="http://www.w3.org/2000/svg"', '')
            .replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" '));
}

export { encodeSvg };
